import { Layout } from 'react-admin';
import HeaderBar from './HeaderBar';
import CustomMenu from './CustomMneu';
import BottomTabMenu from './BottomTabMenu';

const CustomLayout = (props) => (
    <>
        {/* <HeaderBar/> */}
        <Layout
            appBar={HeaderBar}  // カスタムヘッダー
            menu={() => <></>}       // カスタムサイドメニュー
            sidebar={() => <></>}
            {...props}
        />
        <BottomTabMenu />
     </>
);

export default CustomLayout;

